import { AnimatePresence, motion } from 'motion/react';
import { BaleInboundContextProvider, BaleInboundPageType } from './context';
import { BaleInboundErrorHandler } from './error-handler';
import { useBaleInboundContext } from './hook';
import { BaleInboundFooter } from './inbound-footer';
import { BaleInboundAddLoadPhotosPage } from './subroutes/add-load-photos';
import { ManualInboundAddScanPage } from './subroutes/inbound-bale-scan-add';
import { BaleInboundDocketEditPage } from './subroutes/inbound-docket-edit';
import { InboundDocketPhotoPage } from './subroutes/inbound-docket-photo';
import { BaleInboundLoadConfirmationPage } from './subroutes/inbound-load-confirmation';
import { ManualInboundLoadCreatePage } from './subroutes/inbound-load-create';
import { BaleInboundLoadEvaluatePage } from './subroutes/inbound-load-evaluate';
import { BaleInboundRootPage } from './subroutes/inbound-root';
import { BaleInboundScanPage } from './subroutes/inbound-scan';
import { ManualCreateScanRemovePage } from './subroutes/manual-create-scan-remove';
import { ReceivingScanAddPage } from './subroutes/receiving-scan-add';

export const BaleInboundPage = () => {
	return (
		<BaleInboundContextProvider>
			<BaleInboundPageRoot />
		</BaleInboundContextProvider>
	);
};

const BaleInboundPageRoot = () => {
	return (
		<AnimatePresence>
			<SubRoute key="RECEIVING" id="RECEIVING" component={<BaleInboundRootPage />} />
			<SubRoute key="INITIAL_SCAN" id="INITIAL_SCAN" component={<BaleInboundScanPage />} />
			<SubRoute key="SCAN_ADD" id="SCAN_ADD" component={<ReceivingScanAddPage />} />
			<SubRoute key="DOCKET_EDIT" id="DOCKET_EDIT" component={<BaleInboundDocketEditPage />} />
			<SubRoute key="EVALUATION" id="EVALUATION" component={<BaleInboundLoadEvaluatePage />} />
			<SubRoute
				key="CONFIRMATION"
				id="CONFIRMATION"
				component={<BaleInboundLoadConfirmationPage />}
			/>
			<SubRoute
				key="MANUAL_CREATE:ROOT"
				id="MANUAL_CREATE:ROOT"
				component={<ManualInboundLoadCreatePage />}
			/>
			<SubRoute
				key="MANUAL_CREATE:ADD_BALE"
				id="MANUAL_CREATE:ADD_BALE"
				component={<ManualInboundAddScanPage />}
			/>
			<SubRoute
				key="MANUAL_CREATE:REMOVE_BALE"
				id="MANUAL_CREATE:REMOVE_BALE"
				component={<ManualCreateScanRemovePage />}
			/>
			<SubRoute key="DOCKET_PHOTO" id="DOCKET_PHOTO" component={<InboundDocketPhotoPage />} />
			<SubRoute
				key="ADD_LOAD_PHOTOS"
				id="ADD_LOAD_PHOTOS"
				component={<BaleInboundAddLoadPhotosPage />}
			/>
			<BaleInboundFooter />
			<BaleInboundErrorHandler />
		</AnimatePresence>
	);
};

const SubRoute = ({ id, component }: { id: BaleInboundPageType; component: React.ReactNode }) => {
	const { page } = useBaleInboundContext();

	if (page !== id) return null;

	return (
		<motion.div
			key={id}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3 }}
		>
			{component}
		</motion.div>
	);
};
